import { render } from "./responses-table.vue?vue&type=template&id=5f583006&lang=pug"
import script from "./responses-table.vue?vue&type=script&lang=js"
export * from "./responses-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__